var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWashingMachineSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M960 959.968a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64v-896a64 64 0 0 1 64-64h768a64 64 0 0 1 64 64v896z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M848 111.968m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z",
    fill: "#3AAD73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512 639.968m-256 0a256 256 0 1 0 512 0 256 256 0 1 0-512 0Z",
    fill: "#469FCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512 415.968c135.968 0 246.912 106.112 255.2 240 0.352-5.312 0.8-10.592 0.8-16a256 256 0 0 0-512 0c0 5.408 0.48 10.688 0.8 16 8.288-133.888 119.232-240 255.2-240z",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M512 319.968c-176.704 0-320 143.296-320 320s143.296 320 320 320 320-143.296 320-320-143.296-320-320-320z m0 576a256 256 0 1 1 0-512 256 256 0 0 1 0 512z",
    fill: "#434854"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M667.776 552.992l-67.872-67.872a16 16 0 0 0-22.624 22.624l67.872 67.872a16 16 0 0 0 22.624-22.624zM532.832 506.944a16 16 0 0 0-22.624 22.624l113.12 113.12a16 16 0 0 0 22.624-22.624l-113.12-113.12z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M384 111.968a48 48 0 0 1-48 48h-160a48 48 0 0 1 0-96h160a48 48 0 0 1 48 48z",
    fill: "#434854"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M336 159.936h-160a47.872 47.872 0 0 1-45.056-32 47.456 47.456 0 0 0-2.944 16 48 48 0 0 0 48 48h160a48 48 0 0 0 48-48c0-5.632-1.152-10.976-2.944-16-6.624 18.592-24.192 32-45.056 32zM64 223.968h896v32H64zM893.056 127.936c-6.624 18.592-24.192 32-45.056 32s-38.432-13.408-45.056-32a47.456 47.456 0 0 0-2.944 16 48 48 0 0 0 96 0c0-5.632-1.152-10.976-2.944-16z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashingMachineSvgrepoCom);
export default __webpack_public_path__ + "static/media/washing-machine-svgrepo-com.96a4dca524d62e7cdcb8be119c165e65.svg";
export { ForwardRef as ReactComponent };